<template>
  <div class="main" style="position: relative">
    <report-top> </report-top>
    <div id="formTable" style="padding-top: 8px">
      <Form :model="tableForm" :label-width="80" style="margin: 0px 0 0px 0">
        <Row>
          <Col span="24" style="display: flex">
            <FormItem label="车牌号">
              <Input
                @on-focus="openVideo = true"
                v-model="tableForm.carNo"
                placeholder="点击选择车牌号"
                style="width: 180px"
              ></Input>
            </FormItem>
            <FormItem label="通道号">
              <Select v-model="channel" size="small" style="width: 100px">
                <Option :value="1">1通道</Option>
                <Option :value="2">2通道</Option>
                <Option :value="3">3通道</Option>
                <Option :value="4">4通道</Option>
                <Option :value="5">5通道</Option>
                <Option :value="6">6通道</Option>
              </Select>
            </FormItem>
            <FormItem label="时间段"></FormItem>
            <DatePicker
              type="datetime"
              v-model="startEndTime[0]"
              style="width: 180px"
            ></DatePicker>
            <span style="margin: 4px 4px 0 4px">至</span>
            <DatePicker
              type="datetime"
              v-model="startEndTime[1]"
              style="width: 180px"
            ></DatePicker>
            <Button
              style="margin-left: 20px; height: 30px"
              type="primary"
              @click="chaxun"
              >立即查询</Button
            >
          </Col>
        </Row>
      </Form>
    </div>
    <!-- <Split v-model="split" min="0" max="400" id="asceeass">
      <div slot="left" ref="left" class="demo-split-pane" style="height: 100%">
        视频列表
        <ul>
          <li v-for="(item, index) in recordfiles" :key="index">
            {{ utils.time(item.begintime) }}到{{ utils.time(item.endtime) }}
            <a @click="bofang(item)">播放</a>
            <a @click="close(item)">暂停</a>
          </li>
        </ul>
      </div>
      <div
        slot="right"
        class="demo-split-pane"
        ref="right"
        style="height: 100%"
      ></div>
    </Split>-->
    <Table
      :data="recordfiles"
      :columns="columns"
      stripe
      ref="table"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(210)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" type="primary" @click="bofang(row)">回放</Button>
        <Button size="small" @click="downloadFile(row)">下载</Button>
      </template>
    </Table>
    <Drawer
      title="车辆选择"
      placement="left"
      :closable="false"
      v-model="openVideo"
      width="250"
      :styles="{ padding: 0 }"
    >
      <p slot="header" style="display: none">选择车辆</p>
      <my-tree
        ref="fleetTree"
        modal="video"
        @car="reCarNo"
        v-if="openVideo"
        filterGroup='车辆'
      ></my-tree>
    </Drawer>
    <Modal
      v-model="videoModel"
      :mask-closable="false"
      footer-hide
      @on-cancel="close"
      width="700"
    >
      <div id="caecc">
        <p>
          开始时间：{{ playing.begin }}；结束时间：{{
            playing.end
          }}；视频时长：{{ playing.time }}分钟
        </p>
        <p>
          播放开始：第
          <Input
            v-model="start"
            style="width: 80px; height: 20px; margin: 0 10px"
            :readonly="isPlay"
          ></Input
          >分钟；
          <Button
            type="error"
            size="small"
            style="margin-right: 10px"
            :disabled="!isPlay"
            @click="close"
            >停止</Button
          >
          <Button
            type="primary"
            size="small"
            :disabled="isPlay"
            @click="bofang(playing)"
            >播放</Button
          >
        </p>
      </div>
      <div id="videoHistoryWrap">
        <div id="videoHistory"></div>
      </div>
    </Modal>
  </div>
</template>
<script>
let playList = [];
let player = null;
let tidObj = null;
let allChannelArr = [];
import myTree from "../locate/locateToolCarPerson.vue";
export default {
  props: ["leftLoteData"],
  components: { myTree },
  data() {
    return {
      split: "300",
      tableForm: {
        carNo: "",
        deviceNo: "",
      },
      dayList: [
        {
          value: -3,
          label: "近三天",
        },
        {
          value: -7,
          label: "近七天",
        },
        {
          value: -15,
          label: "近15天",
        },
        {
          value: -30,
          label: "近30天",
        },
        {
          value: 10,
          label: "自定义",
        },
      ],
      day: -7,
      startEndTime: [new Date(Date.now() - 86400 * 1000 * 3), new Date()],
      channel: 1,
      openVideo: false,
      videoModel: false,
      recordfiles: [],
      columns: [
        {
          type: "index",
          tooltip: true,
          align: "center",
        },
        {
          title: "文件大小(M)",
          key: "file",
          tooltip: true,
        },
        {
          title: "时长/分",
          key: "time",
          tooltip: true,
        },
        {
          title: "通道",
          key: "channel",
          tooltip: true,
        },
        {
          title: "开始时间",
          key: "begin",
          tooltip: true,
        },
        {
          title: "结束时间",
          key: "end",
          tooltip: true,
        },
        {
          title: "操作",
          slot: "action",
          tooltip: true,
        },
      ],
      playing: {},
      isPlay: false,
      start: 0,
    };
  },
  methods: {
    beforCcreatePlayer() {
      this.videoModal = true;
      if (player != null) {
        player.destroy();
        player = null;
        playList = [];
        tidObj = null;
        this.videoModal = false;
        setTimeout(() => {
          this.videoModal = true;
          this.isPlay = true;
          setTimeout(() => {
            this.createPlayer();
          }, 100);
        }, 100);
      } else {
        setTimeout(() => {
          this.createPlayer();
        }, 100);
      }
    },
    createPlayer() {
      player = new byskplayer({
        id: "videoHistory", //容器
        baseURL: "wss://videostream.car900.com/", //路径
        //baseURL: 'wss://videostream.car900.com/07B7ED0A57724C7705F2C27E13ED57DA',
        // userkey: "c4d1fbb6-2dc5-4f86-a5da-893f80e9d80a", //客户代码
        userkey: "2161e23a-4d3b-4d1a-bf0a-cafd56f9c6f8", //客户代码
        //userkey: '9c6386c7-4987-4a30-ac90-43ad22900a9f',
        isReal: false, //是否实时
        isRecord: true, //是否回放
        userId: "apidemo", //用户id,
        click: this.onPlayClick,
        playstart: this.onPlayStart,
        playend: this.onPlayEnd,
        isSwitchCodetypeOnFullscreen: false, //全屏是否切换高清，默认false
      });

      //player.poster = "static/poster.png"; //设置预览图片
      this.mySetPlayerNum(1); //设置视频画面
    },
    mySetPlayerNum(t) {
      player.setPlayerNum(t);
    },
    reCarNo(v) {
      if (v.realTimeStatus == 3 || v.realTimeStatus == 4) {
        this.tableForm = {
          carNo: v.carNo,
          deviceNo: v.deviceNo,
        };
        this.openVideo = false;
      } else {
        this.$Message.error("青选择停留或者行驶的车");
      }
    },
    reSelectVehicle(v) {
      this.$emit("send", v);
      //
    },
    //查询视频
    chaxun() {
      if (
        this.tableForm.carNo.length == 0 ||
        this.startEndTime[0].length == 0 ||
        this.startEndTime[1].length == 0
      ) {
        this.$Message.error("车牌号或时间段必须填写完整");
        return;
      }
      this.utils.loading(this, "加载中");
      let params = {
        device: this.tableForm.deviceNo, //终端号
        channel: this.channel, //通道号
        protocolType: 1, //协议类型，1：GF-1078，2：GA系列
        begintime: Math.round(this.startEndTime[0].getTime() / 1000), //开始时间（时间戳，精确至秒）
        endtime: Math.round(this.startEndTime[1].getTime() / 1000), //结束时间（时间戳，精确至秒）
        alarmSign: 0, //报警类型（目前只支持：0）
      };
      player.record.query(params, (res) => {
        this.$Spin.hide(); //关闭加载
        if (res.status == 1) {
          var data = res.recordfiles;
          this.recordfiles = data;
          for (const i in data) {
            this.recordfiles[i].file = (
              data[i].filesize /
              (1024 * 1024)
            ).toFixed(2);
            this.recordfiles[i].time = (
              (data[i].endtime - data[i].begintime) /
              60000
            ).toFixed(0);
            this.recordfiles[i].begin = this.utils.time(data[i].begintime);
            this.recordfiles[i].end = this.utils.time(data[i].endtime);
          }
        }
      });
    },
    //视频满屏
    setScreen() {
      this.$store.state.isMapScreen = !this.$store.state.isMapScreen;
    },
    bofang(v) {
      this.playing = v;
      this.isPlay = true;
      this.videoModel = true;
      if (this.start > this.playing.time || this.start < 0) {
        this.$Message.error("时间设置不合理");
        return;
      }

      let params = {
        device: v.device,
        channel: v.channel,
        protocolType: 1, //协议类型，1：GF-1078,GB-1078;2：GA系列
        begintime: v.begintime / 1000 + this.start * 60,
        endtime: v.endtime / 1000,
        //endtime: v.begintime / 1000 + 10,
        //fileName:  null,
      };
      console.log(params);
      //const T = protocolTypeDom.options[protocolTypeDom.selectedIndex].innerText
      //GB-1078音视频分离
      /* if (['GB-1078'].includes(T)) {
          params.datatype = 0;
        } */

      let obj = playList.find(
        (p) => p.device == device && p.channel == channel
      );
      if (obj) return;
      let tidObj = player.allocate(1);
      if (tidObj.flag == 1) {
        let tid = tidObj.ids[0];
        player.record.open(
          tid,
          params,
          (res) => {
            //console.log(res);
          },
          {
            // hasAudio: !['GB-1078'].includes(T), //GB-1078音视频分开，默认不请求音频
          }
        );
        playList.push({
          ...params,
        });
      } else {
        alert(tidObj.msg);
      }
    },
    downloadFile(v) {
      console.log(v);
      let params = {
        device: v.device,
        channel: v.channel,
        protocolType: 1,
        begintime: v.begintime / 1000,
        endtime: v.endtime / 1000,
        fileName: v.fileName,
        //plate: "测试车辆",
        //vehicleId: "4321",
        //groupId: "1"
      };
      player.ftp.downloadFile(params, (res) => {
        console.log(res);
        if (res.status == 2 && res.media_address) {
          saveAsFile(res.media_address.video_address);
        }
      });
      function saveAsFile(src, filename) {
        let a = document.createElement("a");
        a.href = src;
        a.target = "_blank";
        a.download = filename || src.substr(src.lastIndexOf("/"));
        a.click();
      }
    },
    //Ga设备下载
    GadownloadFile(v) {
      let params = {
        device: v.device,
        channel: v.channel,
        protocolType: 1,
        begintime: v.begintime / 1000 + this.start * 60,
        endtime: v.endtime / 1000,
        fileName: null,
        //plate: "测试车辆",
        //vehicleId: "4321",
        //groupId: "1"
      };
      player.gaDownload.downloadFile(params, (res) => {
        console.log(res);
        if (res.status && res.media_address) {
          saveAsFile(res.media_address.video_address);
        }
      });
      function saveAsFile(src, filename) {
        let a = document.createElement("a");
        a.href = src;
        a.target = "_blank";
        a.download = filename || src.substr(src.lastIndexOf("/"));
        a.click();
      }
    },
    close() {
      this.isPlay = false;
      this.start = 0;
      var v = this.playing;
      let device = v.device;
      let channel = v.channel;
      let index = playList.findIndex(
        (p) => p.device == device && p.channel == channel
      );
      let obj = playList[index];
      if (obj)
        player.record.close(
          obj.tid,
          {
            device: obj.device,
            channel: obj.channel,
            protocolType: obj.protocolType,
          },
          (res) => {
            console.log(res);
          }
        );
      playList.splice(index, 1);
    },
  },
  mounted() {
    this.beforCcreatePlayer();
  },
};
</script>
<style lang="">
#asceeass {
  height: calc(100% - 50px);
}
#videoHistoryWrap {
  width: 100%;
  height: 400px;
}
#caecc {
  width: 100%;
}
#caecc p {
  width: 100%;
  height: 40px;
  display: flex;
}
#caecc p input {
  height: 20px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/video/carVideoHistory.vue